export interface DictionaryTerm {
    id: string;
    term: string;
    category: '공조' | '냉동' | '에어컨' | '전기' | '배관' | '일반';
    description: string;
    relatedTerms?: string[];
}

export const dictionaryTerms: DictionaryTerm[] = [
    {
        id: 'd1',
        term: 'RT (냉동톤)',
        category: '냉동',
        description: '냉동 능력의 단위. 1RT = 3,024kcal/h = 3.517kW. 미국에서 사용하는 단위로, 1톤의 얼음을 24시간 동안 0°C로 만드는 냉동 능력.',
        relatedTerms: ['kW', 'kcal/h', 'HP'],
    },
    {
        id: 'd2',
        term: 'HP (마력)',
        category: '전기',
        description: '동력의 단위. 1HP = 0.746kW. 압축기 모터의 출력을 나타낼 때 사용.',
        relatedTerms: ['kW', 'RT'],
    },
    {
        id: 'd3',
        term: '냉매 (Refrigerant)',
        category: '냉동',
        description: '증발과 응축을 반복하며 열을 이동시키는 작동 유체. R22, R410A, R32, R134a 등이 있으며, 환경 규제에 따라 사용 제한이 점차 강화되고 있음.',
        relatedTerms: ['R410A', 'R32', 'GWP'],
    },
    {
        id: 'd4',
        term: 'R410A',
        category: '냉동',
        description: 'HFC계 냉매. 오존층 파괴 계수(ODP)가 0이지만 GWP가 높음(2088). 2025년부터 신규 설치 제한 예정(유럽 기준).',
        relatedTerms: ['냉매', 'R32', 'GWP', 'ODP'],
    },
    {
        id: 'd5',
        term: 'R32',
        category: '냉동',
        description: 'HFC계 냉매. GWP가 R410A의 약 1/3 수준(675)으로 환경 부하가 적음. 가연성이 있어 취급 주의 필요.',
        relatedTerms: ['냉매', 'R410A', 'GWP'],
    },
    {
        id: 'd6',
        term: 'GWP (지구온난화 잠재력)',
        category: '일반',
        description: 'Global Warming Potential. CO2를 1로 했을 때 해당 물질의 온난화 영향 정도. 냉매 선택 시 중요한 지표.',
        relatedTerms: ['ODP', '냉매', 'R410A'],
    },
    {
        id: 'd7',
        term: 'ODP (오존층 파괴 계수)',
        category: '일반',
        description: 'Ozone Depletion Potential. R11을 1로 했을 때 오존층 파괴 정도. 0이면 오존층 무해.',
        relatedTerms: ['GWP', '냉매'],
    },
    {
        id: 'd8',
        term: '공조기 (AHU)',
        category: '공조',
        description: 'Air Handling Unit. 공기를 처리(냉난방, 가습, 제습, 정화)하여 실내로 보내는 장치. 팬, 필터, 열교환기, 댐퍼 등으로 구성.',
        relatedTerms: ['열교환기', '필터', '댐퍼'],
    },
    {
        id: 'd9',
        term: '열교환기',
        category: '공조',
        description: '두 유체 사이에서 열을 교환하는 장치. 코일(Coil) 형태로 제작되며, 동관+알루미늄 핀 구조가 일반적.',
        relatedTerms: ['공조기', '코일', '핀'],
    },
    {
        id: 'd10',
        term: '과냉도 (Subcooling)',
        category: '냉동',
        description: '응축기를 거쳐 나온 냉매 액체가 포화온도보다 더 낮아진 상태. 적정 과냉도(약 5°C)는 시스템 효율에 중요.',
        relatedTerms: ['과열', '응축기', '냉매'],
    },
    {
        id: 'd11',
        term: '과열 (Superheat)',
        category: '냉동',
        description: '증발기를 거쳐 나온 냉매 기체가 포화온도보다 더 높아진 상태. 압축기 보호를 위해 필요(약 5-10°C).',
        relatedTerms: ['과냉도', '증발기', '냉매'],
    },
    {
        id: 'd12',
        term: '증발기',
        category: '냉동',
        description: '저압 저온의 냉매가 증발하며 주변 열을 흡수하는 열교환기. 실내기(실내 열교환기)의 핵심 부품.',
        relatedTerms: ['응축기', '열교환기', '과열'],
    },
    {
        id: 'd13',
        term: '응축기',
        category: '냉동',
        description: '고압 고온의 냉매 기체가 응축하여 열을 방출하는 열교환기. 실외기(실외 열교환기)의 핵심 부품.',
        relatedTerms: ['증발기', '열교환기', '과냉도'],
    },
    {
        id: 'd14',
        term: '콘덴서 (Condenser)',
        category: '냉동',
        description: '응축기의 다른 명칭. 냉동기에서는 주로 수냉식(쉘&튜브), 에어컨에서는 공냉식(핀&튜브)을 사용.',
        relatedTerms: ['응축기', '증발기'],
    },
    {
        id: 'd15',
        term: '컴프레서 (Compressor)',
        category: '냉동',
        description: '냉매 기체를 압축하여 고압 고온 상태로 만드는 장치. 스크롤, 로터리, 리시프로, 스크류 타입 등이 있음.',
        relatedTerms: ['냉매', '증발기', '응축기'],
    },
    {
        id: 'd16',
        term: '팬 코일 유닛 (FCU)',
        category: '에어컨',
        description: 'Fan Coil Unit. 팬과 열교환기(코일)로 구성된 실내기. 냉온수를 공급받아 실내 공기를 처리.',
        relatedTerms: ['공조기', '코일', '팬'],
    },
    {
        id: 'd17',
        term: '치드 (Chiller)',
        category: '냉동',
        description: '냉수 또는 냉온수를 생산하는 대형 냉동 장치. 흡수식(가스/증기 동력)과 전기식(컴프레서 동력)으로 분류.',
        relatedTerms: ['냉동기', '냉수', '냉온수'],
    },
    {
        id: 'd18',
        term: '냉수 (Chilled Water)',
        category: '배관',
        description: '냉동기에서 생산된 저온의 물. 보통 5-7°C로 공급되어 FCU나 AHU에서 열교환에 사용.',
        relatedTerms: ['냉동기', '치드', '온수'],
    },
    {
        id: 'd19',
        term: '온수 (Hot Water)',
        category: '배관',
        description: '보일러나 히트펌프에서 생산된 고온의 물. 보통 45-60°C로 공급되어 난방에 사용.',
        relatedTerms: ['보일러', '히트펌프', '냉수'],
    },
    {
        id: 'd20',
        term: '히트펌프 (Heat Pump)',
        category: '에어컨',
        description: '냉동 사이클을 역이용하여 저온 열원에서 고온으로 열을 이동시키는 장치. 냉난방 겸용이 가능.',
        relatedTerms: ['에어컨', '냉동 사이클', 'COP'],
    },
    {
        id: 'd21',
        term: 'COP (성적계수)',
        category: '일반',
        description: 'Coefficient Of Performance. 소비 전력 대비 냉난방 능력의 비율. 값이 높을수록 효율이 좋음. 보통 3-6 범위.',
        relatedTerms: ['EER', 'SEER', '히트펌프'],
    },
    {
        id: 'd22',
        term: 'EER (에너지효율비)',
        category: '일반',
        description: 'Energy Efficiency Ratio. 냉방 능력(kW) / 소비 전력(kW). COP와 유사하나 단위가 다름.',
        relatedTerms: ['COP', 'SEER'],
    },
    {
        id: 'd23',
        term: 'SEER (계절에너지효율비)',
        category: '일반',
        description: 'Seasonal Energy Efficiency Ratio. 계절 변화를 반영한 평균 EER. 실제 사용 조건에서의 효율을 더 정확히 반영.',
        relatedTerms: ['EER', 'COP'],
    },
    {
        id: 'd24',
        term: 'DVM (Digital Variable Multi)',
        category: '에어컨',
        description: '삼성전자의 VRF 시스템 상표명. 인버터 컴프레서로 냉매 유량을 가변 제어하여 효율을 높임.',
        relatedTerms: ['VRF', '인버터', '냉매'],
    },
    {
        id: 'd25',
        term: 'VRF (Variable Refrigerant Flow)',
        category: '에어컨',
        description: '냉매 유량 가변 방식의 다중 분할 에어컨 시스템. 1대의 실외기에 여러 실내기 연결 가능.',
        relatedTerms: ['DVM', '인버터', '냉매'],
    },
];